module.exports = __webpack_public_path__ + "static/media/icon_scan.09e1433f.svg";